import { get, includes } from 'lodash';
import Post from '../post';
import styles from '../../pages/page.module.scss';
import { whitelistedPages } from '../../constants/ads';
import Ad from '../Ads/Ad';
import classNames from 'classnames';
import Modal from 'react-modal';
import { ReactSVG } from 'react-svg';
import { default as x } from '../../public/x.svg';
import { trackClientExternalLink } from '../../analytics/client-event-tracking';
import { AccountContext } from '../../contexts';
import { useContext } from 'react';


// To do: Tove this into utils. Try to use AdManager.
function placeAds(posts, rowSize) {
    const _posts = [];
    posts.forEach((post, i) => {
        _posts.push(post);
        const j = i + rowSize + 1;
        const group = 3 * rowSize;
        if (j % group === 0) {
            const num = Math.round(j / group);
            if (num > 5) {
                _posts.push({ type: 'ad', adType: 'promo-inline-infinite' });
            } else {
                _posts.push({ type: 'ad', adType: `promo-inline-${num}` });
            }
        }
    });

    return _posts;
}

function Main({
    modalImage,
    modalOpen,
    pageType,
    platform,
    posts,
    selectedPost,
    setModalContents,
    toggleModal
}) {
    const account = useContext(AccountContext);
    const isWhitelisted = includes(whitelistedPages, pageType);
    const threeColumn = platform === 'tiktok';
    const _posts = isWhitelisted ? placeAds(posts, threeColumn ? 3 : 2) : posts;


    const trackMultilinkClick = ({ postId, postPosition, title, url, linkPosition }) => {
        // not doing any GA tracking for now
        trackClientExternalLink(account, {
            unit_type: 'feed',
            unit_name: 'main',
            subunit_type: 'card_modal',
            subunit_name: title,
            item_type: 'button',
            item_name: postId.toString(),
            position_in_unit: postPosition,
            position_in_subunit: linkPosition,
            target_content_url: url
        });
    };

    return (
        <main className={classNames(styles.main, threeColumn && styles['force-3-column'])}>
            <h2>Recent Posts</h2>
            {_posts.map((post, i) =>
                post.type !== 'ad' ?
                    <Post
                        key={i}
                        position={i}
                        post={post}
                        platform={platform}
                        setModalContents={setModalContents}
                        toggleModal={toggleModal}
                    /> :
                    <Ad key={i} type={post.adType} />
            )}
            <Modal
                className={styles.modal}
                isOpen={modalOpen}
                onRequestClose={toggleModal}
                shouldCloseOnEsc={true}
                contentLabel="Select a link"
            >
                <div className={styles.tapTarget} onClick={toggleModal}>
                    <ReactSVG
                        className={styles.icon}
                        src={x}
                    />
                </div>
                <div className={styles.modalContents}>
                    <div className={styles.modalImage}>
                        {modalImage}
                    </div>
                    {get(selectedPost, ['multilink'], null)?.map((link, i) => {
                        return(
                            <a
                                key={i}
                                className={styles.multilink}
                                href={link.url}
                                onClick={() => {
                                    trackMultilinkClick({
                                        title: link.title,
                                        url: link.url,
                                        linkPosition: i,
                                        postPosition: _posts.findIndex(post => post.id === selectedPost.id),
                                        postId: selectedPost.id
                                    });
                                }}
                            >
                                {link.title}
                            </a>
                        );
                    })}
                </div>
            </Modal>
        </main>
    );
}

export default Main;
